import { render, staticRenderFns } from "./LessonWidget.vue?vue&type=template&id=f50eb1f2&scoped=true"
import script from "./LessonWidget.vue?vue&type=script&lang=js"
export * from "./LessonWidget.vue?vue&type=script&lang=js"
import style0 from "./LessonWidget.vue?vue&type=style&index=0&id=f50eb1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50eb1f2",
  null
  
)

export default component.exports